const getters = {
  trainer: (state) => {
    return state.trainer
  },
  istrainer: (state) => {
    return state.istrainer 
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/trainer/getters.js